/* 引入校验文件 */
/*eslint-disable*/
export default {
  mounted() {
    this.isPhoneFun()
    // this.resizeRem()
    window.onresize = this.resizeRem
  },
  methods: {
    resizeRem() {
      const html = document.documentElement
      const windowWidth = html.clientWidth
      html.style.fontSize = `${(windowWidth / 750) * 100}px`
    },
    isPhoneFun() {
      if (!/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
        this.$tsignData.registerPage({
          PlatformType: /(?:iphone|android)/i.test(navigator.userAgent) ? 'H5' : 'WEB',
        })
      }
    },
  },
  computed: {
    pub() {
      return this.$route.query.pub
    },
  },
}
